import React, { useEffect, useState } from "react";
import { Users, CheckCircle, Clock, XCircle } from "lucide-react";
import { api } from "@/lib/api";

const StatCard = ({ title, value, icon: Icon, colorClass }) => (
  <div className="bg-white rounded-xl border border-slate-200 p-6 flex items-center shadow-sm">
    <div className={`p-4 rounded-xl mr-5 ${colorClass}`}>
      <Icon className="w-6 h-6" />
    </div>
    <div>
      <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-1">{title}</h3>
      <p className="text-3xl font-heading font-bold text-slate-800">{value}</p>
    </div>
  </div>
);

export default function Dashboard() {
  const [stats, setStats] = useState({
    total_requests: 0,
    approved_requests: 0,
    pending_requests: 0,
    rejected_requests: 0,
  });

  useEffect(() => {
    api.get("/agent/dashboard")
      .then(r => setStats(r.data))
      .catch(() => {});
  }, []);

  return (
    <div>
      <h2 className="font-heading font-bold text-2xl text-brand-nav mb-6">Agent Dashboard</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <StatCard title="Total Leads" value={stats.total_requests} icon={Users} colorClass="bg-blue-100 text-blue-600" />
        <StatCard title="Pending" value={stats.pending_requests} icon={Clock} colorClass="bg-amber-100 text-amber-600" />
        <StatCard title="Approved" value={stats.approved_requests} icon={CheckCircle} colorClass="bg-emerald-100 text-emerald-600" />
        <StatCard title="Rejected" value={stats.rejected_requests} icon={XCircle} colorClass="bg-red-100 text-red-600" />
      </div>
    </div>
  );
}
